var map = {
	"./BaseActionMenu.vue": "5647",
	"./BaseOutlineInput.vue": "053d",
	"./BaseRadioButton.vue": "4d6e",
	"./BaseRadioGroup.vue": "ad7b",
	"./BaseSelect.vue": "d291",
	"./BaseWidgetTitle.vue": "6691",
	"./Cards/BaseWrapper.vue": "24bf",
	"./Common/BaseInput.vue": "87d9",
	"./Common/BaseTimeInput.vue": "298a",
	"./Common/Buttons/BaseButton.vue": "41ec",
	"./Navbar/BaseNavbar.vue": "d32b",
	"./Widgets/BaseDate.vue": "ec84",
	"./Widgets/OldBaseButton.vue": "474b",
	"./svg/IconAddWidget.svg": "e3d8",
	"./svg/IconAllwidgets.svg": "328f",
	"./svg/IconArrowDown.svg": "2859",
	"./svg/IconArrowUp.svg": "4ba7",
	"./svg/IconAverageAllCalls.svg": "6c78",
	"./svg/IconAverageIncomingCalls.svg": "5711",
	"./svg/IconAverageOutgoingCalls.svg": "a223",
	"./svg/IconCardsGrid.svg": "444c",
	"./svg/IconCheck.svg": "d201",
	"./svg/IconClose.svg": "52fd",
	"./svg/IconCloseBtn.svg": "af7f",
	"./svg/IconCloseOutline.svg": "7491",
	"./svg/IconConfirm.svg": "f01f",
	"./svg/IconDelete.svg": "e11e",
	"./svg/IconDialer.svg": "2ea1",
	"./svg/IconDirDown.svg": "266b",
	"./svg/IconDirLeft.svg": "b375",
	"./svg/IconDirRight.svg": "76b1",
	"./svg/IconDirUp.svg": "d8a9",
	"./svg/IconDiscard.svg": "10c4",
	"./svg/IconDuplicate.svg": "a36a",
	"./svg/IconEdit.svg": "ebd6",
	"./svg/IconEqualizerFill.svg": "1195",
	"./svg/IconExtensions.svg": "92c4",
	"./svg/IconExtensionsTable.svg": "4d46",
	"./svg/IconExternal.svg": "d341",
	"./svg/IconExtraOptions.svg": "454e",
	"./svg/IconFace.svg": "8fee",
	"./svg/IconGridLine.svg": "900d",
	"./svg/IconGroup.svg": "fc8c",
	"./svg/IconIncoming.svg": "6385",
	"./svg/IconInfo.svg": "a0fa",
	"./svg/IconLineChart.svg": "9f68",
	"./svg/IconList.svg": "2655",
	"./svg/IconLogoVoicenter.svg": "66a5",
	"./svg/IconMinimize.svg": "85ee",
	"./svg/IconMinus.svg": "d211",
	"./svg/IconNoData.svg": "a1f1",
	"./svg/IconNoDataCry.svg": "98fe",
	"./svg/IconNoDataFunnel.svg": "ea4b",
	"./svg/IconOutgoing.svg": "7184",
	"./svg/IconPerformance.svg": "acc3",
	"./svg/IconPhone.svg": "f8dc",
	"./svg/IconPlus.svg": "dd97",
	"./svg/IconPlusCircle.svg": "af5a",
	"./svg/IconQuestion.svg": "497a",
	"./svg/IconRealtimeTable.svg": "f404",
	"./svg/IconSave.svg": "f7b6",
	"./svg/IconSettings.svg": "b2a3",
	"./svg/IconShapeMini.svg": "0699",
	"./svg/IconSimpleArrowLeft.svg": "e959",
	"./svg/IconSimpleArrowRight.svg": "01e9",
	"./svg/IconStats.svg": "e425",
	"./svg/IconTrash.svg": "76e0",
	"./svg/IconUpload.svg": "60e5",
	"./svg/IconUsers.svg": "fc8e",
	"./svg/Navbar/IconAddDashboard.svg": "1636",
	"./svg/Navbar/IconAvatar.svg": "c8f0",
	"./svg/Navbar/IconExitFullScreen.svg": "0a8e",
	"./svg/Navbar/IconExitFullScreenMode.svg": "9bc1",
	"./svg/Navbar/IconFullScreen.svg": "d5b2",
	"./svg/Navbar/IconHorisontalLine.svg": "51c0",
	"./svg/Navbar/IconListView.svg": "809d",
	"./svg/Navbar/IconNewGroup.svg": "4879",
	"./svg/Navbar/IconOptions.svg": "914a",
	"./svg/Navbar/IconPencil.svg": "167e",
	"./svg/Navbar/IconTabbedView.svg": "7a5f",
	"./svg/auto-completes/IconAccounts.svg": "0122",
	"./svg/auto-completes/IconCampaigns.svg": "4c42",
	"./svg/auto-completes/IconDids.svg": "1157",
	"./svg/auto-completes/IconExtension.svg": "539e",
	"./svg/auto-completes/IconQueues.svg": "dcb0",
	"./svg/auto-completes/IconUser.svg": "a34d",
	"./svg/auto-completes/IconUsers.svg": "62f7",
	"./svg/dashboard-settings/IconAdd.svg": "2097",
	"./svg/dashboard-settings/IconArrowBack.svg": "3b2c",
	"./svg/dashboard-settings/IconCheck.svg": "b6de",
	"./svg/dashboard-settings/IconCircle.svg": "6831",
	"./svg/dashboard-settings/IconColorPicker.svg": "1556",
	"./svg/dashboard-settings/IconColorPickerSimple.svg": "8b62",
	"./svg/dashboard-settings/IconColorSettings.svg": "1c5d",
	"./svg/dashboard-settings/IconCrossedEye.svg": "467c",
	"./svg/dashboard-settings/IconDashboardColor.svg": "3ff5",
	"./svg/dashboard-settings/IconDashboardLogo.svg": "bbed",
	"./svg/dashboard-settings/IconDashboardName.svg": "5625",
	"./svg/dashboard-settings/IconDragAndDrop.svg": "af83",
	"./svg/dashboard-settings/IconFonts.svg": "b428",
	"./svg/dashboard-settings/IconLayoutSelection.svg": "cc9a",
	"./svg/dashboard-settings/IconMoveDown.svg": "d642",
	"./svg/dashboard-settings/IconMoveUp.svg": "5679",
	"./svg/dashboard-settings/IconNewLayout.svg": "3c4d",
	"./svg/dashboard-settings/IconShape.svg": "35c4",
	"./svg/dashboard-settings/IconTextSettings.svg": "0abf",
	"./svg/dashboard-settings/IconTimer.svg": "afa7",
	"./svg/dashboard-settings/IconTimerSettings.svg": "8088",
	"./svg/dashboard-settings/IconTimerSm.svg": "90ce",
	"./svg/dashboard-settings/IconVerticalLine.svg": "feb6",
	"./svg/dashboard-settings/IconWidgetGroup.svg": "702f",
	"./svg/dashboard-settings/IconZoomIn.svg": "5ca9",
	"./svg/dashboard-settings/IconZoomOut.svg": "72ef",
	"./svg/dashboard-templates/IconAll.svg": "3a32",
	"./svg/dashboard-templates/IconIvr.svg": "9933",
	"./svg/dashboard-templates/IconQueue.svg": "7993",
	"./svg/dashboard-templates/IconTemplate.svg": "4411",
	"./svg/report/IconActionColumn.svg": "32af",
	"./svg/report/IconActions.svg": "b64d",
	"./svg/report/IconAddReport.svg": "da05",
	"./svg/report/IconArrowSimpleDown.svg": "62cb",
	"./svg/report/IconAuthor.svg": "92ec",
	"./svg/report/IconBtnDelete.svg": "33a9",
	"./svg/report/IconCalendar.svg": "337a",
	"./svg/report/IconChangeOrder.svg": "4166",
	"./svg/report/IconCondition.svg": "50ad",
	"./svg/report/IconDaily.svg": "88b0",
	"./svg/report/IconDragAndDrop.svg": "5e25",
	"./svg/report/IconDuplicate.svg": "f950",
	"./svg/report/IconEllipse.svg": "4d4f",
	"./svg/report/IconEllipseOuter.svg": "b3d8",
	"./svg/report/IconEmailBody.svg": "e842",
	"./svg/report/IconEmailGroup.svg": "7280",
	"./svg/report/IconFormatColumn.svg": "7536",
	"./svg/report/IconInterval.svg": "54bb",
	"./svg/report/IconMonthly.svg": "810f",
	"./svg/report/IconParameters.svg": "8539",
	"./svg/report/IconPdf.svg": "a3fe",
	"./svg/report/IconRemove.svg": "7821",
	"./svg/report/IconReportBrand.svg": "6b6c",
	"./svg/report/IconReportColumn.svg": "eb18",
	"./svg/report/IconReportName.svg": "ce9f",
	"./svg/report/IconScheduleColumn.svg": "d74b",
	"./svg/report/IconSettings.svg": "53e6",
	"./svg/report/IconSpreadsheet.svg": "25ad",
	"./svg/report/IconStore.svg": "cdc9",
	"./svg/report/IconWidget.svg": "b585",
	"./svg/report/IconWidgetColumn.svg": "2460",
	"./svg/report/IconWidgetDefault.svg": "cead",
	"./svg/report/IconWidgetName.svg": "ad93",
	"./svg/report/IconWidgetSelection.svg": "d1fd",
	"./svg/statuses/IconAdministrative.svg": "b278",
	"./svg/statuses/IconAtWork.svg": "8d5b",
	"./svg/statuses/IconBrief.svg": "e28d",
	"./svg/statuses/IconDirectionIncoming.svg": "4823",
	"./svg/statuses/IconDirectionOutgoing.svg": "ddee",
	"./svg/statuses/IconHold.svg": "69ce",
	"./svg/statuses/IconIncomingCall.svg": "8609",
	"./svg/statuses/IconLogin.svg": "10fe",
	"./svg/statuses/IconLogout.svg": "c610",
	"./svg/statuses/IconLunch.svg": "7644",
	"./svg/statuses/IconOther.svg": "366e",
	"./svg/statuses/IconPrivate.svg": "5054",
	"./svg/statuses/IconRedBulb.svg": "f2b6",
	"./svg/statuses/IconTeamMeeting.svg": "815a",
	"./svg/statuses/IconThreshold.svg": "a05c",
	"./svg/statuses/IconTotalOutgoingCalls.svg": "9457",
	"./svg/statuses/IconTraining.svg": "fa3d",
	"./svg/statuses/IconYellowBulb.svg": "7b04",
	"./svg/templates/IconTemplateChart.svg": "42d7",
	"./svg/templates/IconTemplateCounter.svg": "c653",
	"./svg/templates/IconTemplateDefault.svg": "c522",
	"./svg/templates/IconTemplatePie.svg": "6059",
	"./svg/templates/IconTemplateTable.svg": "8dc0",
	"./svg/templates/template-helps/IconThelpChart.svg": "9ad6",
	"./svg/templates/template-helps/IconThelpCounter.svg": "06990",
	"./svg/templates/template-helps/IconThelpDefault.svg": "6581",
	"./svg/templates/template-helps/IconThelpPie.svg": "b7a3",
	"./svg/templates/template-helps/IconThelpTable.svg": "a4d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d733";